import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactInfo = () => {
  const contactDetails = [
    {
      icon: 'MapPin',
      title: 'Our Location',
      content: `30/1, Tank Street, Velappanaickenpudur,\nChinnavedampatti, Coimbatore – 641049`,
      action: () => window.open('https://www.google.com/maps/dir/?api=1&destination=Maayo+Laundry+and+Dry+cleaning', '_blank'),
      actionText: 'Get Directions'
    },
    {
      icon: 'Phone',
      title: 'Phone Numbers',
      content: `Customer Service: +91 96000 44004\nPickup & Delivery: +91 96000 44004`,
      // action: () => window.open('tel:+919600044004'),
      actionText: 'Call Now'
    },
    {
      icon: 'Mail',
      title: 'Email Address',
      content: `General Inquiries: info@maayolaundry.com\nCustomer Support: support@maayolaundry.com`,
      action: () => window.open('mailto:info@maayolaundry.com'),
      actionText: 'Send Email'
    },
    {
      icon: 'Clock',
      title: 'Business Hours',
      content: `Monday - Saturday: 8:00 AM - 9:00 PM\nSunday: 8:00 AM - 9:00 PM (Pickup only)\nPickup Available: 7:00 AM - 9:00 PM`,
      action: null,
      actionText: null
    }
  ];

  const socialLinks = [
    { icon: 'Facebook', url: 'https://facebook.com/maayolaundry', label: 'Facebook' },
    { icon: 'Instagram', url: 'https://instagram.com/maayolaundry', label: 'Instagram' },
    // { icon: 'Twitter', url: 'https://twitter.com/maayolaundry', label: 'Twitter' },
    { icon: 'MessageCircle', url: 'https://wa.me/919600044004', label: 'WhatsApp' }
  ];

  const emergencyInfo = {
    title: 'Emergency Contact',
    description: 'For urgent pickup requests or service issues outside business hours',
    phone: '+91 96000 44004',
    available: '24/7 Emergency Line'
  };

  return (
    <div className="space-y-8">
      {/* Contact Details */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="bg-card rounded-2xl p-8 shadow-elevation-2"
      >
        <h2 className="text-3xl font-bold text-foreground mb-8">
          Contact Information
        </h2>
        
        <div className="space-y-6">
          {contactDetails?.map((detail, index) => (
            <motion.div
              key={detail?.title}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: 0.1 * index }}
              className="flex items-start space-x-4 p-4 rounded-xl hover:bg-muted/50 transition-smooth"
            >
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name={detail?.icon} size={24} color="var(--color-primary)" />
              </div>
              
              <div className="flex-1">
                <h3 className="font-semibold text-foreground mb-2">
                  {detail?.title}
                </h3>
                <p className="text-muted-foreground whitespace-pre-line leading-relaxed mb-3">
                  {detail?.content}
                </p>
                
                {detail?.action && (
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={detail?.action}
                    iconName="ExternalLink"
                    iconPosition="right"
                    className="text-primary hover:text-primary-foreground hover:bg-primary transition-smooth"
                  >
                    {detail?.actionText}
                  </Button>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
      {/* Emergency Contact */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.4 }}
        className="bg-gradient-to-r from-error/5 to-warning/5 rounded-2xl p-6 border border-error/20"
      >
        <div className="flex items-start space-x-4">
          <div className="w-12 h-12 bg-error/10 rounded-lg flex items-center justify-center flex-shrink-0">
            <Icon name="AlertCircle" size={24} color="var(--color-error)" />
          </div>
          
          <div className="flex-1">
            <h3 className="font-semibold text-foreground mb-2">
              {emergencyInfo?.title}
            </h3>
            <p className="text-muted-foreground mb-3 leading-relaxed">
              {emergencyInfo?.description}
            </p>
            
            <div className="flex flex-col sm:flex-row gap-3">
              <p
                // onClick={() => window.open(`tel:${emergencyInfo?.phone}`)}
                className="border-error text-error hover:text-error-foreground transition-smooth"
              >
                {emergencyInfo?.phone}
              </p>  
              <span className="text-sm text-muted-foreground self-center">
                {emergencyInfo?.available}
              </span>
            </div>
          </div>
        </div>
      </motion.div>
      {/* Social Media Links */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.6 }}
        className="bg-card rounded-2xl p-8 shadow-elevation-2"
      >
        <h3 className="text-xl font-semibold text-foreground mb-6">
          Follow Us
        </h3>
        
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          {socialLinks?.map((social, index) => (
            <motion.button
              key={social?.label}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.3, delay: 0.1 * index }}
              onClick={() => window.open(social?.url, '_blank')}
              className="flex flex-col items-center p-4 rounded-xl bg-muted/50 hover:bg-primary hover:text-primary-foreground transition-smooth hover:hover-scale group"
            >
              <Icon 
                name={social?.icon} 
                size={24} 
                className="mb-2 group-hover:scale-110 transition-smooth" 
              />
              <span className="text-sm font-medium">{social?.label}</span>
            </motion.button>
          ))}
        </div>
      </motion.div>
    </div>
  );
};

export default ContactInfo;